"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComposeEmailDialogStyles = void 0;
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var StyleFunctions_1 = require("../../style/StyleFunctions");
var ComposeEmailDialogStyles;
(function (ComposeEmailDialogStyles) {
    ComposeEmailDialogStyles.PREFIX = 'compose-email-dialog';
    ComposeEmailDialogStyles.DIALOG_WIDTH = 500;
    ComposeEmailDialogStyles.TEXT_AREA_HEIGHT = 200;
    ComposeEmailDialogStyles.MAXIMUM_BODY_LENGTH = 4000;
    ComposeEmailDialogStyles.MAXIMUM_SUBJECT_LENGTH = 78;
    function TEST_ID(suffix) {
        return ComposeEmailDialogStyles.PREFIX + suffix;
    }
    ComposeEmailDialogStyles.TEST_ID = TEST_ID;
    ComposeEmailDialogStyles.LabelTextDiv = LayoutComponents_1.divWithStyle(TEST_ID('label-text'), {
        paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
        paddingBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
        fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
        color: widgets_1.TabStyles.Typography.Color.Primary,
    });
    ComposeEmailDialogStyles.RecipientsDiv = LayoutComponents_1.divWithStyle(TEST_ID('recipients'), {
        paddingBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    });
    ComposeEmailDialogStyles.subjectStyle = {
        width: '100%'
    };
    ComposeEmailDialogStyles.subjectContainer = StyleFunctions_1.cssClass('subjectContainerClass', __assign({}, ComposeEmailDialogStyles.subjectStyle));
    ComposeEmailDialogStyles.messageAreaStyle = {
        height: ComposeEmailDialogStyles.TEXT_AREA_HEIGHT,
        resize: 'none'
    };
    ComposeEmailDialogStyles.messageAreaClass = StyleFunctions_1.cssClass(TEST_ID('text-area'), {
        outline: 'none',
        boxSizing: 'border-box',
        width: '100%',
        overflow: 'auto',
        fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
        marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
        paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
        paddingBottom: widgets_1.TabStyles.Spacing.DefaultSpace
    });
    ComposeEmailDialogStyles.emailButtonStyle = {
        marginLeft: widgets_1.TabStyles.Spacing.LargeSpace,
    };
    ComposeEmailDialogStyles.buttonStyleSubmitting = {
        verticalAlign: 'sub',
    };
    ComposeEmailDialogStyles.dialogBodyStyle = {
        paddingTop: widgets_1.TabStyles.Spacing.MediumSpace,
        paddingBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    };
})(ComposeEmailDialogStyles = exports.ComposeEmailDialogStyles || (exports.ComposeEmailDialogStyles = {}));
//# sourceMappingURL=ComposeEmailDialogStyles.js.map